import { Component, OnInit, ContentChildren, Input, AfterViewInit, OnDestroy } from '@angular/core';
import { QueryList } from '@angular/core';
import { Subject } from 'rxjs';
import { ChipNotResponsiveComponent } from '../chip-notResponsive/chip-notResponsive.component';

@Component({
  selector: 'app-chips-list-notResponsive',
  templateUrl: './chips-list-notResponsive.component.html',
  styleUrls: ['./chips-list-notResponsive.component.scss'],
})
export class ChipsListNotResponsiveComponent implements AfterViewInit, OnDestroy {
  private ngUnsubscribe: Subject<void> = new Subject<void>();

  @ContentChildren(ChipNotResponsiveComponent) chips: QueryList<ChipNotResponsiveComponent>;
  constructor() {}

  multiple: boolean = false;

  ngAfterViewInit() {
    this.chips.toArray().forEach((item) => {
      item.select.takeUntil(this.ngUnsubscribe).subscribe((args) => {
        if (args) {
          this.itemSelected(args as any);
        }
      });
    });

    this.chips.changes.subscribe((change) => {
      this.chips.toArray().forEach((item) => {
        //item.select.unsubscribe();
        item.select.takeUntil(this.ngUnsubscribe).subscribe((args) => {
          if (args) {
            this.itemSelected(args as any);
          }
        });
      });
    });
  }

  itemSelected(item: ChipNotResponsiveComponent) {
    if (!this.multiple) {
      this.chips.toArray().forEach((item, index) => {
        item.selected = false;
      });
      item.selected = true;
    } else {
      item.selected = !item.selected;
    }
  }

  /**
   * On destroy cancel active subscriptions
   */
  public ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/theme/components/chips/chips-list-notResponsive/chips-list-notResponsive.component.ts